import apiConfig, {
  ERROR_TIMEOUT,
  ADD_SUCCESS_MESSAGE,
  DEFAULT_ERROR_MESSAGE,
  INVALID_SESSION,
} from "../../App.config";
import setLoaderAction from "./loaderAction";
import types from "../actionTypes";
import * as apiServices from "../../services/apiServices";
import * as toastAction from "../actions/toastAction";
import history from "../../utilities/history";
import * as utilities from "../../utilities/utils";
import { isSessionValid } from "./profileAction";

/************************************ ACTIONS ****************************************/

function setManagerApplicationCountAction(managerApplicationCount) {
  return {
    type: types.SET_MANAGER_TOTAL_APP_COUNT,
    managerApplicationCount,
  };
}

/************************************ ACTION CREATORS ****************************************/

export const getManagerTotalapplicationsCount = () => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getManagerTotalApplicationsCount()
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setManagerApplicationCountAction(data.totalApplicationCount));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};
